import { render, staticRenderFns } from "./SelectDemo.vue?vue&type=template&id=22b8c57a&scoped=true&"
import script from "./SelectDemo.vue?vue&type=script&lang=js&"
export * from "./SelectDemo.vue?vue&type=script&lang=js&"
import style0 from "./SelectDemo.vue?vue&type=style&index=0&id=22b8c57a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8c57a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b8c57a')) {
      api.createRecord('22b8c57a', component.options)
    } else {
      api.reload('22b8c57a', component.options)
    }
    module.hot.accept("./SelectDemo.vue?vue&type=template&id=22b8c57a&scoped=true&", function () {
      api.rerender('22b8c57a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/SelectDemo.vue"
export default component.exports